module.exports = __webpack_public_path__ + "media/images/doorsticker-416527d0c45540271a1489135cdba37f.jpeg";